<template>
    <v-dialog v-model="dialog" max-width="600">
        <Loader ref="Loader"></Loader>

        <v-card>
            <v-card-title>
                Duplicate Allocations
            </v-card-title>
            <v-card-text>
                <v-form ref="form">
                    <!-- <v-select :items="selectOptions" box full-width label="From Month" v-model="fromMonth"></v-select> -->
                    <v-select :items="availableMonths" box full-width label="To Month" v-model="toMonth"></v-select>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="duplicate">Duplicate</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            fromMonth: null,
            toMonth: null,
            selectOptions: [{
                text: 'January',
                value: 1
            }, {
                text: 'February',
                value: 2
            }, {
                text: 'March',
                value: 3
            }, {
                text: 'April',
                value: 4
            }, {
                text: 'May',
                value: 5
            }, {
                text: 'June',
                value: 6
            }, {
                text: 'July',
                value: 7
            }, {
                text: 'August',
                value: 8
            }, {
                text: 'September',
                value: 9
            }, {
                text: 'October',
                value: 10
            }, {
                text: 'November',
                value: 11
            }, {
                text: 'December',
                value: 12
            }]
        }
    },
    mounted() { },
    computed: {
        availableMonths() {
            return this.selectOptions.filter(el => el.value > this.fromMonth);
        }
    },
    methods: {
        show(fromMonth) {
            this.dialog = true;
            this.fromMonth = fromMonth;
        },
        close() {
            this.dialog = false;
        },
        duplicate() {
            this.$emit(`duplicate`, {
                from: this.fromMonth,
                to: this.toMonth
            })
            this.close();
        }
    }
}
</script>